/*
This page calls sidebar component ( which shows the icons. So when clicked they are taken to respective page), navbar component ( which renders 
title of page, logged-in user's first name and a logout button) and home component (which calls updated time component, refresh button, download 
component, dropbox (for selection of aws account), checkbox (for selection of cluster and namespace), search input box (filters the table records 
based on the given input) and the table component).
*/

import Home from "../components/ServiceInventoryDashboard/Home";
import SideNavBar from "../components/NavBar/SideBar"
import Navbar from '../components/NavBar/Navbar';

const ServiceInventoryPage = () =>{
    return (
        <div style={{ display: 'flex', width:'100% !important', position: 'fixed'}}>
            <SideNavBar />
            <div style={{  width: '50% !important' }}>
                <div className="navbar-content">
                    <Navbar title="Service Inventory"/>
                </div> 
                <Home/>
            </div>
        </div>
    );
}

export default ServiceInventoryPage;
